import axios from './axios.js'

// 用户余额
export function userList(limit, page) {
    return axios.get(`/finance_clear/consumer_wallet?limit=${limit}&page=${page}`)
}

// 用户奖罚处理
export function userPrizePenalty(data) {
    return axios.post('finance_clear/bonus', data)
}


// WEBPACK FOOTER //
// ./src/api/userApi.js